import { type ChangeEvent, type ComponentProps, useEffect, useRef } from "react";
import styles from "./ImportCheckbox.module.css";

type ImportCheckboxProps = Omit<ComponentProps<"input">, "type" | "ref"> & {
  indeterminate?: boolean;
};

/** A checkbox drawn as a small rounded box. `indeterminate` shows the bar and sets the native property. */
export function ImportCheckbox({
  indeterminate = false,
  className,
  onChange,
  ...inputProps
}: ImportCheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const classes = [styles.checkbox, className].filter(Boolean).join(" ");

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  });

  function keepIndeterminate(event: ChangeEvent<HTMLInputElement>) {
    onChange?.(event);
    event.currentTarget.indeterminate = indeterminate;
  }

  return (
    <span className={classes}>
      <input
        {...inputProps}
        ref={inputRef}
        type="checkbox"
        className={styles.input}
        onChange={keepIndeterminate}
      />
      <span className={styles.box} aria-hidden="true" />
    </span>
  );
}
